import React from 'react';

import { Badge, Space, Tabs, type TabsProps } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import ErrorBoundary from '@modules/core/components/ErrorBoundary';
import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import {
  useGetMBCDashboardQuery,
  useGetMeritBadgeCounselorProfileQuery,
} from '@modules/meritBadgeCounselors/api';
import PageContainer from '@shared/components/Layouts/PageContainer';
import { currentUserMIDSel } from '@user/duck/selectorsTyped';

import { toApproveCountSel } from '../duck/selectors';
import TabDashboardApprove from './TabDashboardApprove';
import TabDashboardYouth from './TabDashboardYouth';

function MBCDashboardPageContainer() {
  const memberId = useSelector(currentUserMIDSel);
  const toApproveCount = useSelector(toApproveCountSel);
  useGetMeritBadgeCounselorProfileQuery({ memberId }, { skip: !memberId });
  useGetMBCDashboardQuery({ personGuidOrMID: memberId }, { skip: !memberId });
  const tabs: TabsProps['items'] = [
    {
      key: 'tab-youth',
      children: <TabDashboardYouth />,
      label: <FormattedMessage id="mbcDashboard.tabs.youths" />,
    },
    {
      key: 'tab-toApprove',
      children: <TabDashboardApprove />,
      label: (
        <Space align="center">
          <FormattedMessage id="mbcDashboard.tabs.toApprove" />

          <Badge count={toApproveCount} />
        </Space>
      ),
    },
  ];

  return (
    <ErrorBoundary>
      <PageContainer>
        <Tabs
          destroyInactiveTabPane
          items={tabs}
          defaultActiveKey="tab-youth"
        />
      </PageContainer>
    </ErrorBoundary>
  );
}
function MBCDashboardPageWrapper() {
  if (!featureFlags.getFlag('SBL_4405_SHOW_MBC_DASHBOARD')) return null;

  return <MBCDashboardPageContainer />;
}

export default MBCDashboardPageWrapper;
